import { useCallback } from 'react';

const normalizeTargets = (rawTargets) => {
  if (rawTargets == null) return ['chat', 'articles'];
  if (Array.isArray(rawTargets)) {
    const normalized = rawTargets
      .map((target) => String(target || '').trim().toLowerCase())
      .filter(Boolean);
    return normalized.length > 0 ? normalized : ['chat', 'articles'];
  }
  if (typeof rawTargets === 'string') {
    const split = rawTargets
      .split(',')
      .map((target) => target.trim().toLowerCase())
      .filter(Boolean);
    return split.length > 0 ? split : ['chat', 'articles'];
  }
  return ['chat', 'articles'];
};

const resolveProviderType = (dataset) => {
  if (!dataset) return 'unknown';
  if (dataset.dataset_type === 'external_api') return 'tenant_api_connector';
  if (dataset.dataset_type === 'wordpress') return 'tenant_mcp_connector';
  if (dataset.dataset_type === 'file_upload') return 'openai_source';
  if (dataset.type === 'external_api') return 'tenant_api_connector';
  return 'openai_source';
};

const toAvailabilityLabel = (targets) => {
  const normalized = normalizeTargets(targets);
  const hasChat = normalized.includes('chat');
  const hasArticles = normalized.includes('articles');

  if (hasChat && hasArticles) return 'Both';
  if (hasChat) return 'Assistant';
  if (hasArticles) return 'Articles';
  return 'None';
};

const toProviderLabel = (providerType) => {
  switch (providerType) {
    case 'tenant_api_connector':
      return 'External API';
    case 'tenant_mcp_connector':
      return 'MCP';
    case 'openai_source':
      return 'OpenAI';
    case 'platform_connector':
      return 'Platform';
    case 'tenant_postgres_source':
      return 'Postgres';
    default:
      return 'Unknown';
  }
};

const useDatasetProviders = () => {
  const getTargets = useCallback((dataset) => normalizeTargets(dataset?.data_sets), []);

  const getAvailabilityLabel = useCallback((dataset) => toAvailabilityLabel(dataset?.data_sets), []);

  const getProviderType = useCallback((dataset) => resolveProviderType(dataset), []);

  const getProviderLabel = useCallback((dataset) => {
    const providerType = resolveProviderType(dataset);
    return toProviderLabel(providerType);
  }, []);

  return {
    getTargets,
    getAvailabilityLabel,
    getProviderType,
    getProviderLabel
  };
};

export default useDatasetProviders;